import { render, staticRenderFns } from "./CashDesks.vue?vue&type=template&id=5e81056b"
import script from "./CashDesks.vue?vue&type=script&lang=js"
export * from "./CashDesks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports